import { UpOutlined } from '@ant-design/icons';
import { Collapse } from 'antd';
import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import styles from './AppImportantMatters.module.scss';
const { Panel } = Collapse;

const AppImportantMatters = ({ content }: any) => {
    const { t } = useTranslation();
    const [collapsed, setCollapsed] = useState(false);
    return (
        <div className={styles.content}>
            <Collapse
                className={classNames({ panelOpend: !collapsed })}
                expandIcon={({ isActive }) => <UpOutlined rotate={isActive ? 180 : 0} />}
                expandIconPosition='end'
                defaultActiveKey={['0']}
                ghost
                onChange={() => setCollapsed(!collapsed)}
            >
                <Panel
                    header={<div className={styles.title}>{content.ImportantMatterName.value}</div>}
                    key='0'
                >
                    {
                        <div
                            dangerouslySetInnerHTML={{
                                __html: content.ImportantMatterContent.value,
                            }}
                        ></div>
                    }
                </Panel>
            </Collapse>
        </div>
    );
};

export default AppImportantMatters;
